/**
 * Login terms component, separated from login component so it can be applied differently in modal for example
 */

import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { YAGA_EXTERNALS } from '../../config/fe-routes';

type LoginTermsProps = {
  type?: 'page' | 'component';
  className?: string;
};

const LoginTerms = forwardRef((props: LoginTermsProps, ref: React.Ref<any>) => {
  const { type, className } = props;
  const { t } = useTranslation();

  const componentType = type || 'page';

  return (
    <div
      className={classNames('login-terms', `type-${componentType}`, className)}
      ref={ref}
      dangerouslySetInnerHTML={{
        __html: t('components.login.terms', {
          termsUrl: YAGA_EXTERNALS.TERMS().href,
          privacyUrl: YAGA_EXTERNALS.PRIVACY_POLICY().href,
        }),
      }}
    />
  );
});

export default LoginTerms;
